import CheckAuthPage from './check-auth';

export default CheckAuthPage;